import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'udp-container-query',
  styleUrl: 'udp-container-query.css',
  shadow: true,
})
export class UdpContainerQuery {
  @Prop() queries: { [breakpoint: number]: { [key: string]: string } } = {};
  @Prop() customClass?: string;

  private getContainerQueryStyle(): string {
    // Create dynamic container query styles
    const styleRules = Object.entries(this.queries)
      .map(([breakpoint, styles]) => {
        const cssProperties = Object.entries(styles)
          .map(([property, value]) => `${property}: ${value};`)
          .join('\n      ');

        return `
  @container (min-width: ${breakpoint}px) {
    ::slotted(*) {
      ${cssProperties}
    }
  }`;
      })
      .join('\n');

    return styleRules;
  }

  render() {
    return (
      <Host
        class={{
          [this.customClass]: !!this.customClass,
        }}
      >
        <style>{this.getContainerQueryStyle()}</style>
        <slot></slot>
      </Host>
    );
  }
}
